// @flow
import React from 'react';

import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import type { Pinner } from 'app/packages/pinterest-flow-types/user';
import { normalizeSearchQuery } from 'app/common/react/components/discover/lib/searchQueryUtils';
import { Box, Text } from 'gestalt';

type Props = {
  feedbackType: string,
  pinner: ?Pinner,
  topic: string,
};

export default function ImageOnlyAttribution(props: Props) {
  const { feedbackType, topic } = props;
  const pinner = props.pinner || {};
  const pinnerName = pinner.full_name;
  const isTopic = feedbackType === 'topic';
  const isFollowed = !isTopic && feedbackType === 'followed';
  const pinnerUrl = `/${pinner.username}/`;
  const searchQuery = normalizeSearchQuery(topic);
  const searchUrl = `/search/pins/?q=${encodeURIComponent(searchQuery)}&rs=image_only_attribution`;
  const navigateUrl = isTopic ? searchUrl : pinnerUrl;

  const feedbackTypes = {
    topic: i18n._('From {topic}', 'attribution on pin rep'),
    followed: i18n._('From {pinnerName}', 'attribution on pin rep'),
    pfyBoard: i18n._('Picked for you', 'attribution on pin rep'),
    pfy: i18n._('Picked for you', 'attribution on pin rep'),
  };

  const attribution = feedbackTypes[feedbackType];

  if (!attribution) {
    return null;
  }

  if (isFollowed || isTopic) {
    const isStart = attribution.indexOf('{') === 0;
    const topicOrPinnerName = isTopic ? topic : pinnerName;
    const attributionText = isStart
      ? attribution.slice(attribution.indexOf('}') + 1)
      : attribution.slice(0, attribution.indexOf('{'));
    if (isStart) {
      return (
        <Box display="inlineBlock" marginTop={1}>
          <NavigateLink to={navigateUrl}>
            <Text inline size="xs" truncate weight="bold">
              {topicOrPinnerName}
            </Text>
          </NavigateLink>
          <Text inline size="xs">
            {attributionText}
          </Text>
        </Box>
      );
    } else {
      return (
        <Box display="inlineBlock" marginTop={1}>
          <Text inline size="xs">
            {attributionText}
          </Text>
          <NavigateLink to={navigateUrl}>
            <Text inline size="xs" truncate weight="bold">
              {topicOrPinnerName}
            </Text>
          </NavigateLink>
        </Box>
      );
    }
  } else {
    return (
      <Box display="inlineBlock" marginTop={1}>
        <Text inline size="xs">
          {attribution}
        </Text>
      </Box>
    );
  }
}
